import CryptoJS from "crypto-js";
import KeyPair from "protico-encryption/dist/KeyPair";
import { v4 as uuidv4 } from "uuid";
import { getStableBasicProfile } from "../hooks/useBasicProfile";
import { TMessage } from "../types/types";

/**
 *
 * @param toAddress
 * @param userKeypair
 * @returns targetPubKey
 * @raise Error(): raise error when the target is not ready for dm
 */
export const checkDM = async (toAddress: string) => {
  const targetProfile = await getStableBasicProfile(toAddress);
  console.log("checkDM: ", targetProfile);
  const targetPubKeyStr = targetProfile?.public_key;
  if (!targetPubKeyStr) {
    throw new Error(
      "Chat start before user has a private key. \nThis should not happened"
    );
  }
  var targetPubKey: Uint8Array;
  try {
    targetPubKey = new Uint8Array(Buffer.from(targetPubKeyStr, "base64"));
  } catch (e) {
    throw new Error(
      "Something wrong happended when tried to decode the target's pub key"
    );
  }
  return targetPubKey;
};

export const decrypt = (
  message: TMessage,
  userKeypair: KeyPair,
  userAddress: string
) => {
  // console.log("message: ", message);
  // console.log("userKeypair: ", userKeypair);
  // console.log("userAddress: ", userAddress);
  const targetPubKeyStr =
    message.fromAddress === userAddress
      ? message.toPubKeyBase64
      : message.fromPubKeyBase64;
  const targetPubKey = new Uint8Array(Buffer.from(targetPubKeyStr, "base64"));
  try {
    const decryptedMsg = userKeypair.decrypt(
      targetPubKey,
      message.messageText
    ) as string;
    if (hashFromString(decryptedMsg) === message.msgSha256Base64)
      return decryptedMsg;
  } catch (e) {
    console.log("real reason: ", e);
  }
  throw new Error("Decrypt fail");
};
export const hashFromString = (msg: string) => {
  var hash = CryptoJS.SHA256(msg);
  var base64 = CryptoJS.enc.Base64.stringify(hash);
  return base64;
};

export const generateMessage = (
  fromAddress: string,
  toAddress: string,
  plaintextMessage: string,
  userKeypair: KeyPair,
  toPubKeyUint8: Uint8Array
) => {
  // TODO: do some error handle of this.encrypt
  const messageText = encrypt(plaintextMessage, userKeypair, toPubKeyUint8);
  const message: TMessage = {
    messageText,
    id: uuidv4(),
    fromAddress: fromAddress,
    toAddress: toAddress,
    sended: false,
    msgSha256Base64: hashFromString(plaintextMessage),
    fromPubKeyBase64: Buffer.from(userKeypair.get().public!).toString("base64"),
    toPubKeyBase64: Buffer.from(toPubKeyUint8).toString("base64"),
    cid: "",
    plaintextMessage: "",
  };
  return message;
};
export const encrypt = (
  plaintextMessage: string,
  userKeypair: KeyPair,
  toPubKeyUint8: Uint8Array
) => {
  try {
    return userKeypair.encrypt(toPubKeyUint8, plaintextMessage, true) as string;
  } catch (e) {
    throw new Error("Encrypt fail");
  }
};

export const utilparseMessage = (message: any) => {
  return {
    id: message.id,
    createdAt: message.created_at,
    fromAddress: message.from_address,
    toAddress: message.to_address,
    messageText: message.message_text,
    sended: message.sended,
    msgSha256Base64: message.msg_sha256_base64,
    fromPubKeyBase64: message.from_pub_key_base64,
    toPubKeyBase64: message.to_pub_key_base64,
    cid: message.cid,
    plaintextMessage: "",
    currency: message.currency,
    available: message.available,
    price: message.price,
  } as TMessage;
};
